import React from 'react';
import { Link } from 'react-router-dom';
import { FolderTree, ChevronRight } from 'lucide-react';
import { useT } from '../services/i18n';
import { catName, subName } from '../services/catalogI18n';
import { categoryPath, subcategoryPath } from '../services/catalogPath';

export const AlsoInBlock = ({ product, categories, current }) => {
  const { t, lang } = useT();
  const all = [{ category: product.category, subcategory: product.subcategory || null }, ...(product.extra_categories || [])];
  const others = all.filter(x => !(x.category === current.category && (x.subcategory || null) === (current.subcategory || null)));
  if (!others.length) return null;
  return (
    <section className="bg-white rounded-lg shadow-sm p-4 mb-6" data-testid="product-also-in">
      <h2 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-3"><FolderTree size={16} className="text-orange-500" /> {t('product.alsoIn')}</h2>
      <ul className="flex flex-wrap gap-2">
        {others.map((x, i) => {
          const cat = categories.find(c => c.slug === x.category);
          const label = catName(cat, lang) || x.category;
          const sub = x.subcategory ? subName(cat, x.subcategory, lang) : '';
          const to = x.subcategory ? subcategoryPath(cat || { slug: x.category }, x.subcategory) : categoryPath(x.category);
          return (
            <li key={i}>
              <Link to={to} data-testid={`product-also-in-${i}`} className="inline-flex items-center gap-1 text-sm px-3 py-1.5 rounded-full border border-gray-200 text-gray-700 hover:border-orange-400 hover:text-orange-600 transition-colors">
                {label}{sub && <><ChevronRight size={12} className="text-gray-400" /> {sub}</>}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
